<template>
  <label class="app-checkbox">
    <input
      type="checkbox"
      class="app-checkbox__input"
      :checked="value"
      @change="$emit('input', $event.target.checked)"
    />

    <span class="app-checkbox__icon">
      <svg v-if="value" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <rect width="20" height="20" rx="5" fill="#2B65EB" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.569 6.178a.944.944 0 0 1 1.253.244.944.944 0 0 1-.244 1.253l-4.887 7.306-4.342-3.722a.944.944 0 1 1 1.213-1.428l3.198 2.745 3.809-5.398Z"
          fill="#F2F2F2"
        />
      </svg>

      <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none">
        <rect
          x="1"
          y="1"
          width="18"
          height="18"
          rx="4"
          fill="#E0E6F2"
          stroke="#B9C4D8"
          stroke-width="2"
        />
      </svg>
    </span>

    <span class="app-checkbox__label">
      <slot />
    </span>
  </label>
</template>

<script>
export default {
  name: "AppCheckbox",
  props: { value: Boolean },
};
</script>

<style scoped>
.app-checkbox {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  position: relative;
  padding: 15px;
}

.app-checkbox__input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.app-checkbox__icon {
  display: inline-flex;
  line-height: 0;
  flex-shrink: 0;
}

.app-checkbox__icon svg {
  display: block;
}
</style>
